import {
  type SupportedCardSet,
  isSupportedCardSet,
} from '@sorare/core/src/lib/cardSets';

import commonBaseSetBg from './assets/common-base-set-bg.webp';
import winterSetBg from './assets/winter-set-bg.webp';

type Props = {
  set: Nullable<string>;
};

const SET_BACKGROUNDS: Record<SupportedCardSet, string> = {
  'common-base-set': commonBaseSetBg,
  winter: winterSetBg,
} as const;

export const CollectionSetBackground = ({ set }: Props) => {
  if (!isSupportedCardSet(set)) {
    return null;
  }
  return <img src={SET_BACKGROUNDS[set]} alt={set} />;
};
